import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShare = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#A)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M11.333 12.667C11.333 14.507 9.84 16 8 16H3.333C1.493 16 0 14.507 0 12.667V8c0-1.84 1.493-3.333 3.333-3.333H4a.67.67 0 0 1 .667.667A.67.67 0 0 1 4 6h-.667c-1.1 0-2 .9-2 2v4.667c0 1.1.9 2 2 2H8c1.1 0 2-.9 2-2a.67.67 0 0 1 .667-.667.67.67 0 0 1 .667.667zm4.087-8.74L11.813.2a.66.66 0 0 0-.94-.013c-.26.26-.273.68-.013.94l3.427 3.533h-5.62c-1.84 0-3.333 1.493-3.333 3.333v3.333a.67.67 0 0 0 .667.667.67.67 0 0 0 .667-.667V7.993c0-1.1.9-2 2-2h5.613l-3.427 3.533c-.253.267-.253.687.013.94a.66.66 0 0 0 .467.187.69.69 0 0 0 .48-.2l3.6-3.713a2 2 0 0 0 .007-2.82v.007z",
			fill: "#333"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "A",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgShare;
